/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The IsEnabledResponse model module.
 * @module model/IsEnabledResponse
 * @version 1.0
 */
class IsEnabledResponse {
    /**
     * Constructs a new <code>IsEnabledResponse</code>.
     * @alias module:model/IsEnabledResponse
     */
    constructor() { 
        
        IsEnabledResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IsEnabledResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IsEnabledResponse} obj Optional instance to populate.
     * @return {module:model/IsEnabledResponse} The populated <code>IsEnabledResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IsEnabledResponse();

            if (data.hasOwnProperty('must_show')) {
                obj['must_show'] = ApiClient.convertToType(data['must_show'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * Event must be shown in the menu
 * @member {Boolean} must_show
 */
IsEnabledResponse.prototype['must_show'] = undefined;






export default IsEnabledResponse;

